<template>
  <div class="sub-page">
    <!-- 顶部紫粉渐变 Header -->
    <div class="sub-header">
      <van-nav-bar title="積分兌換" class="sub-nav">
        <template #left>
          <van-icon name="arrow-left" color="#ffffff" size="24" @click="back()" />
        </template>
        <template #right>
          <span class="nav-right-text" @click="$router.push('/WithdrawRecord')">提款記錄</span>
        </template>
      </van-nav-bar>
    </div>

    <!-- 页面内容主体 -->
    <div class="sub-body">
      <!-- 顶栏提款方式卡片 -->
      <div class="method-card" @click="showMethodPopup = true">
        <div class="method-left">
          <span class="method-name">{{ selectedMethodLabel }}</span>
          <i class="van-icon van-icon-arrow-down arrow-icon"></i>
        </div>
        <span class="method-label">提款方式</span>
      </div>

      <!-- 兑换积分卡片 -->
      <div class="withdraw-card">
        <div class="card-title">兌換積分 (TWD)</div>

        <!-- 提取金额输入行 -->
        <div class="amount-row">
          <span class="currency-symbol">TWD</span>
          <input
            type="number"
            v-model="withdraw_money"
            :placeholder="'可用積分' + formatMoney(userInfo.money)"
            class="amount-input"
          />
          <span class="all-btn" @click="allMoney()">全部</span>
        </div>

        <!-- 提款限额提示 -->
        <div class="limit-row">
          <span class="limit-btn" @click="showLimitTip()">
            <i class="question-icon">?</i> 提款限額
          </span>
        </div>

        <!-- 剩余积分 -->
        <div class="remaining-row">
          剩餘積分: {{ formatMoney(remainingMoney) }}TWD
        </div>

        <div class="divider"></div>

        <!-- 资金密码 -->
        <div class="password-row">
          <input
            type="password"
            v-model="paypassword"
            placeholder="請輸入資金密碼"
            class="password-input"
          />
        </div>
      </div>

      <!-- 提款请求大按钮 -->
      <div class="submit-btn" @click="handleWithdrawSubmit()">
        積分提款請求
      </div>
    </div>

    <!-- 底部提款方式选择 ActionSheet Popup -->
    <van-popup
      v-model="showMethodPopup"
      position="bottom"
      :style="{ borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }"
    >
      <div class="method-action-sheet">
        <div
          v-for="item in methodOptions"
          :key="item.value"
          class="method-action-item"
          @click="selectMethod(item)"
        >
          <span class="item-name">{{ item.label }}</span>
          <i v-if="selectedMethod === item.value" class="van-icon van-icon-success check-icon"></i>
        </div>
      </div>
    </van-popup>

    <!-- 未绑定提示弹窗 Modal Popup -->
    <van-popup
      v-model="showUnboundModal"
      position="center"
      :style="{ width: '80vw', borderRadius: '20px', overflow: 'hidden' }"
    >
      <div class="unbound-modal">
        <div class="modal-head">
          <p class="modal-title">提示</p>
        </div>
        <div class="modal-body">
          提款地址尚未綁定。您想綁定它嗎？
        </div>
        <div class="modal-footer">
          <div class="modal-btn cancel-btn" @click="showUnboundModal = false">取消</div>
          <div class="modal-btn confirm-btn" @click="toBindPage()">確認</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      withdraw_money: '',
      paypassword: '',
      selectedMethod: 'bank',
      showMethodPopup: false,
      showUnboundModal: false,
      targetUnboundMethod: 'bank',
      userInfo: {},
      withdrawRole: {},
      is_bind: false,
      is_usdt_trc: false,
      is_usdt_erc: false,
      methodOptions: [
        { label: '金融卡', value: 'bank' },
        { label: 'TRC20', value: 'trc' },
        { label: 'ERC20', value: 'erc' }
      ]
    };
  },
  computed: {
    selectedMethodLabel() {
      const match = this.methodOptions.find(o => o.value === this.selectedMethod);
      return match ? match.label : '金融卡';
    },
    remainingMoney() {
      const total = parseFloat(this.userInfo.money) || 0;
      const input = parseFloat(this.withdraw_money) || 0;
      const res = total - input;
      return res < 0 ? 0 : res;
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    formatMoney(val) {
      if (val === undefined || val === null || val === '') return '0.00';
      const num = parseFloat(val);
      if (isNaN(num)) return '0.00';
      return num.toFixed(2);
    },
    allMoney() {
      this.withdraw_money = String(this.userInfo.money || 0);
    },
    showLimitTip() {
      const min = this.withdrawRole.min || 10;
      const max = this.withdrawRole.max || 100000000;
      this.$toast(`單次提款限額: ${min} - ${max} TWD`);
    },
    checkMethodBound(methodValue) {
      if (methodValue === 'bank') return this.is_bind;
      if (methodValue === 'trc') return this.is_usdt_trc;
      if (methodValue === 'erc') return this.is_usdt_erc;
      return false;
    },
    selectMethod(item) {
      this.showMethodPopup = false;
      this.selectedMethod = item.value;
      if (!this.checkMethodBound(item.value)) {
        this.targetUnboundMethod = item.value;
        this.showUnboundModal = true;
      }
    },
    toBindPage() {
      this.showUnboundModal = false;
      if (this.targetUnboundMethod === 'bank') {
        this.$router.push('/BindCard');
      } else {
        const queryType = this.targetUnboundMethod === 'erc' ? 'ERC20' : 'TRC20';
        this.$router.push({ path: '/BindUsdt', query: { type: queryType } });
      }
    },
    handleWithdrawSubmit() {
      if (!this.checkMethodBound(this.selectedMethod)) {
        this.targetUnboundMethod = this.selectedMethod;
        this.showUnboundModal = true;
        return;
      }
      if (!this.withdraw_money || parseFloat(this.withdraw_money) <= 0) {
        this.$toast(this.$t('setting.correct_money') || '請輸入正確的提款金額');
        return;
      }
      if (parseFloat(this.withdraw_money) > parseFloat(this.userInfo.money || 0)) {
        this.$toast('提款金額不能大於可用積分');
        return;
      }
      if (!this.paypassword) {
        this.$toast(this.$t('my.msg48') || '請輸入資金密碼');
        return;
      }
      this.$http({
        method: 'post',
        data: {
          money: this.withdraw_money,
          type: this.selectedMethod === 'bank' ? 1 : (this.selectedMethod === 'erc' ? 3 : 2),
          paypassword: this.paypassword
        },
        url: 'user_set_withdraw'
      }).then(res => {
        if (res && res.code === 200) {
          this.$toast.success(res.msg || '提交成功');
          this.withdraw_money = '';
          this.paypassword = '';
          this.getUserInfo();
        } else if (res) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          this.userInfo = res.data;
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          if (res.data.is_bank) this.is_bind = true;
          const info = res.data.info || res.data.bank_info || {};
          const trc_addr = info.usdt || info.trc_usdt || '';
          const erc_addr = info.erc_usdt || '';

          this.is_usdt_trc = !!trc_addr;
          this.is_usdt_erc = !!erc_addr;

          this.autoSelectFirstBoundMethod();
        }
      });
    },
    getUserWithdrawRole() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          this.withdrawRole = res.data;
          if (res.data.bank !== undefined) this.is_bind = !!res.data.bank;
          this.autoSelectFirstBoundMethod();
        }
      });
    },
    autoSelectFirstBoundMethod() {
      if (this.is_bind) {
        this.selectedMethod = 'bank';
      } else if (this.is_usdt_trc) {
        this.selectedMethod = 'trc';
      } else if (this.is_usdt_erc) {
        this.selectedMethod = 'erc';
      }
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style scoped>
.sub-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  box-sizing: border-box;
}

/* 顶部 Header */
.sub-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.sub-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px !important;
}

::v-deep .sub-nav .van-icon-arrow-left {
  color: #ffffff !important;
  font-size: 40px !important;
}

.nav-right-text {
  color: #ffffff;
  font-size: 28px;
  cursor: pointer;
}

/* 内容主体 */
.sub-body {
  position: relative;
  margin-top: -60px;
  padding: 0 24px 40px;
  box-sizing: border-box;
}

/* 提款方式卡片 */
.method-card {
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  padding: 28px 30px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;
  cursor: pointer;
}

.method-left {
  display: flex;
  align-items: center;
}

.method-name {
  font-size: 30px;
  font-weight: 700;
  color: #ff3b57;
  margin-right: 12px;
}

.arrow-icon {
  color: #ff3b57;
  font-size: 26px;
}

.method-label {
  font-size: 26px;
  color: #888888;
}

/* 兑换积分卡片 */
.withdraw-card {
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 40px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;
}

.card-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: left;
  margin-bottom: 24px;
}

.amount-row {
  display: flex;
  align-items: center;
  padding-bottom: 12px;
}

.currency-symbol {
  font-size: 32px;
  font-weight: 700;
  color: #4f2b8a;
  margin-right: 16px;
}

.amount-input {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 28px;
  color: #333333;
  padding: 0;
}

.amount-input::-webkit-input-placeholder {
  color: #b0b0b0;
}

.all-btn {
  font-size: 28px;
  font-weight: 600;
  color: #7f38ac;
  cursor: pointer;
  padding-left: 16px;
}

.limit-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  margin-bottom: 20px;
}

.limit-btn {
  font-size: 24px;
  color: #7f38ac;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.question-icon {
  font-style: normal;
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #7f38ac;
  text-align: center;
  line-height: 26px;
  font-size: 20px;
  margin-right: 8px;
}

.remaining-row {
  font-size: 26px;
  color: #8e44ad;
  text-align: left;
  margin: 16px 0 24px;
}

.divider {
  width: 100%;
  height: 1px;
  background: #f0f0f0;
  margin: 24px 0;
}

.password-row {
  display: flex;
  align-items: center;
}

.password-input {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 28px;
  color: #333333;
  padding: 8px 0;
}

.password-input::-webkit-input-placeholder {
  color: #b0b0b0;
}

/* 提款大按钮 */
.submit-btn {
  width: 100%;
  height: 90px;
  line-height: 90px;
  background: linear-gradient(90deg, #db4bc9, #54279e);
  color: #ffffff;
  font-size: 32px;
  font-weight: 600;
  border-radius: 50px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(127, 56, 172, 0.3);
}

/* ActionSheet 下拉菜单 */
.method-action-sheet {
  width: 100%;
  background: #ffffff;
  padding: 10px 0;
}

.method-action-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 96px;
  padding: 0 36px;
  border-bottom: 1px solid #f5f5f5;
  font-size: 28px;
  color: #333333;
  cursor: pointer;
}

.method-action-item:last-child {
  border-bottom: none;
}

.check-icon {
  color: #ff3b57;
  font-size: 32px;
}

/* 未绑定 Modal 弹窗 */
.unbound-modal {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  text-align: center;
}

.modal-head {
  background: linear-gradient(90deg, #9b4bc9, #ea5dbb);
  padding: 24px 0;
}

.modal-title {
  color: #ffffff;
  font-size: 32px;
  font-weight: 600;
  margin: 0;
}

.modal-body {
  padding: 48px 30px;
  font-size: 28px;
  color: #333333;
  line-height: 1.5;
}

.modal-footer {
  display: flex;
  border-top: 1px solid #f0f0f0;
}

.modal-btn {
  flex: 1;
  height: 90px;
  line-height: 90px;
  font-size: 28px;
  cursor: pointer;
}

.cancel-btn {
  color: #666666;
  border-right: 1px solid #f0f0f0;
}

.confirm-btn {
  color: #ff3b57;
  font-weight: 600;
}
</style>
